import { render, staticRenderFns } from "./recharge_lottery.vue?vue&type=template&id=5be7f684&scoped=true"
import script from "./recharge_lottery.vue?vue&type=script&lang=ts"
export * from "./recharge_lottery.vue?vue&type=script&lang=ts"
import style0 from "./recharge_lottery.vue?vue&type=style&index=0&id=5be7f684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be7f684",
  null
  
)

export default component.exports